import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import appConfig from '../../../app-config';
import { showGiftCardModal } from '../../modules/GiftCard/giftCardActions';

import { displayTransferBalanceModal } from '../../modules/Loyalty/loyaltyActions';
import { method } from 'lodash';

const Wrapper = styled.div`
  padding-left: ${(props) => (props.isForCheckoutPage ? '80px' : '0')};
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  max-width: 400px;
  margin-top: 20px;
  border-color: ${(props) => props.theme.addCreditCardBorderColor || '#000000'};
  color: ${(props) => props.theme.addCreditCardBorderColor || '#000000'};
  &:hover {
    border-color: ${(props) => props.theme.addCreditCardBorderColorHover};
    color: ${(props) => props.theme.addCreditCardBorderColorHover || '#000000'};
    transition: all 0.25s ease;
  }
  @media (max-width: 786px) {
    padding-left: 0;
  }
`;

const ButtonWrapper = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: auto auto;
  align-items: center;
  justify-self: center;
  cursor: pointer;
  border: solid 2px #dbdbdb;
  padding: 19px 16px 19px 24px;
  border-radius: 6px;
  width: 100%;
  border-color: ${(props) => props.theme.addCreditCardBorderColor || '#000000'};
  color: ${(props) => props.theme.addCreditCardBorderColor || '#000000'};
  &:hover {
    border-color: ${(props) => props.theme.addCreditCardBorderColorHover};
    color: ${(props) => props.theme.addCreditCardBorderColorHover || '#000000'};
    transition: all 0.25s ease;
  }
`;
const ButtonTextWrapper = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
`;
const AddGiftCardButton = ({
  showGiftCardModal,
  displayTransferBalanceModal,
  paymentMethods,
}) => {
  const { specificGiftCardFlow } = appConfig;
  const loyaltyCardExists = paymentMethods.some(
    (method) => method.type === 'gift_card'
  );
  const giftCardButtonText =
    specificGiftCardFlow && loyaltyCardExists
      ? 'Transfer Balance'
      : '+ Add a Gift Card';
  return (
    <Wrapper>
      <ButtonWrapper
        id='AddGiftCardButton'
        onClick={() => {
          if (specificGiftCardFlow && loyaltyCardExists) {
            displayTransferBalanceModal(true);
          } else {
            showGiftCardModal(true);
          }
        }}
      >
        <ButtonTextWrapper>{giftCardButtonText}</ButtonTextWrapper>
        <div style={{ textAlign: 'right' }}>
          {appConfig.appSource == 'iQ' ? (
            <img src='https://cdn.zeplin.io/5eecf39877a3e0469ce04a0d/assets/0390B5B5-A273-4C1C-B8F6-5B9FC5B54C58.svg' />
          ) : (
            <i
              className='fas fa-gift-card'
              style={{ fontSize: '29px', color: 'inherit' }}
            />
          )}
        </div>
      </ButtonWrapper>
    </Wrapper>
  );
};
const mapStateToProps = (state) => ({
  paymentMethods: state.paymentMethodsReducer.paymentMethods,
});
export default connect(mapStateToProps, {
  showGiftCardModal,
  displayTransferBalanceModal,
})(AddGiftCardButton);
